module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)9.14201ea6.jpg";